import React, { useEffect, useState } from "react";
import PermissionsPageComponent from "./permissionsPage";
import "./permissionsPage.scss";
import { Checkbox, Select, Input } from "antd";
import trash_icn from "../../../../images/trash.svg";
import { amenityList } from "../../../../redux/slice/amenityListSlice";
import { addAmenities } from "../../../../redux/slice/addAmenitiesSlice";
import { societyAmenities } from "../../../../redux/slice/societyAmenitiesSlice";
import { visitorPinSlice } from "../../../../redux/slice/visitorPinSlice";
import { updateVisitorPin } from "../../../../redux/slice/updateVisitorPinSlice";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Notify from "../../common/notify/notify";
import PageLoader from "../../common/pageLoader";
import Loading from "../../common/Loading/loading";
import { Cookies } from "react-cookie";

const Permissions = (props) => {
  const {
    amenityListData,
    callamenityListData,
    calladdAmenitiesData,
    callsocietyAmenitiesData,
    societyAmenitiesData,
    addAmenitiesData,
    callvisitorPinData,
    visitorPinSliceData,
    updateVisitorPinData,
    callupdateVisitorPinData,
  } = props;

  const cookies = new Cookies();
  const id = cookies.get("societyId");
  const [alignValue, setAlignValue] = useState("center");
  const [amenities, setAmenities] = useState([]);
  const [customAmenity, setCustomAmenity] = useState("");
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [visitorPinCheck, setvisitorPinCheck] = useState(false);
  const [directVisitorAccessCheck, setDirectVisitorAccessCheck] =
    useState(false);
  const [lastSelected, setLastSelected] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    callamenityListData();
    callvisitorPinData(id);
  }, []);

  const amenitiesList =
    amenityListData?.amenityListData?.data?.data?.amenities || null;

  const getAmenitiesList =
    societyAmenitiesData?.societyAmenitiesData?.data?.data?.amenities || null;

  const accessDetails =
    visitorPinSliceData?.visitorPinSliceData?.data?.data?.accessDetails;

  const getVisitorPin = accessDetails?.visitorPinAccess;
  const getDirectVisitorAccess = accessDetails?.visitorNotifyAccess;

  useEffect(() => {
    if (typeof getVisitorPin === "boolean") {
      setvisitorPinCheck(getVisitorPin);
    }
    if (typeof getDirectVisitorAccess === "boolean") {
      setDirectVisitorAccessCheck(getDirectVisitorAccess);
    }
  }, [getVisitorPin, getDirectVisitorAccess]);

  const handleCheckboxChange = () => {
    setvisitorPinCheck((prev) => !prev);
  };

  const handleDirectVisitorAccessChange = () => {
    setDirectVisitorAccessCheck((prev) => !prev);
  };

  const handleSocietyAmenities = async () => {
    const result = await callsocietyAmenitiesData(id);
    const data = result?.payload?.data?.data?.amenities;

    if (result.type === "societyAmenities/fulfilled") {
      const transformedAmenities = data.map((item) => ({
        selectedAmenity: item.name,
        isChecked: true,
      }));

      setAmenities((prev) => {
        const mergedAmenities = [
          ...prev,
          ...transformedAmenities.filter(
            (newAmenity) =>
              !prev.some(
                (existingAmenity) =>
                  existingAmenity.selectedAmenity === newAmenity.selectedAmenity
              )
          ),
        ];
        return mergedAmenities;
      });
    }
  };

  useEffect(() => {
    if (id) {
      handleSocietyAmenities();
    }
  }, [id]);

  const handelSelectChange = (value) => {
    if (value === "custom") {
      setShowCustomInput(true);
      return;
    }

    setAmenities((prev) => {
      if (prev.some((item) => item.selectedAmenity === value)) {
        return prev;
      }
      return [...prev, { selectedAmenity: value, isChecked: false }];
    });
    setLastSelected(value);
    setShowCustomInput(false);
  };

  const handleCustomAmenitySubmit = () => {
    const trimmedAmenity = customAmenity.trim();
    if (trimmedAmenity === "") return;

    setAmenities((prev) => {
      if (prev.some((item) => item.selectedAmenity === trimmedAmenity)) {
        return prev;
      }
      return [...prev, { selectedAmenity: trimmedAmenity, isChecked: false }];
    });

    setCustomAmenity("");
  };

  const handleRemoveAmenity = (amenityToRemove) => {
    setAmenities((prev) =>
      prev.filter((item) => item.selectedAmenity !== amenityToRemove)
    );
  };

  const handelSelectedAmenities = (amenity, isChecked) => {
    setAmenities((prev) =>
      prev.map((item) =>
        item.selectedAmenity === amenity ? { ...item, isChecked } : item
      )
    );
  };

  const formatAmenityName = (name) => {
    if (!name) return "";
    return name
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/^\w/, (c) => c.toUpperCase());
  };

  const handleAminitesSubmit = async () => {
    const checkedAmenities = amenities
      .filter((item) => item.isChecked)
      .map((item) => item.selectedAmenity);

    const isUpdateMode = Boolean(getAmenitiesList && getAmenitiesList.length);

    if (!isUpdateMode && checkedAmenities.length === 0) {
      Notify(
        "error",
        "Please select at least one amenity before submitting.",
        ""
      );
      return;
    }

    try {
      const result = await calladdAmenitiesData({
        id,
        amenitiesData: {
          amenities: checkedAmenities,
        },
      });

      if (result.type === "addAmenities/fulfilled") {
        navigate("/society-permissions");
        setLastSelected("");
        Notify(
          "success",
          isUpdateMode
            ? "Amenities have been updated successfully"
            : "Amenities have been added successfully",
          ""
        );
      }

      if (result.type === "addAmenities/rejected") {
        Notify("error", result.error.message, "");
      }
    } catch (error) {
      Notify("error", "Oops! Something went wrong. Please try again later.", "");
    }
  };

  const handleVisitorPinSubmit = async () => {
    const payload = {
      societyId: id,
      visitorPinAccess: visitorPinCheck,
      visitorNotifyAccess: directVisitorAccessCheck,
    };

    const result = await callupdateVisitorPinData(payload);

    if (result.type === "updateVisitorPin/fulfilled") {
      navigate("/society-permissions");
      setLastSelected("");
      Notify(
        "success",
        "Pre-approved visitor access settings have been updated successfully.",
        ""
      );
    }

    if (result.type === "updateVisitorPin/rejected") {
      Notify("error", result.error.message, "");
    }
  };

  const items = [
    {
      key: "1",
      label: "Amenities",
      children: (
        <div className="amenities-main">
          <p className="amenities-text">
            Monitor and manage the amenities of your society. You can add new
            amenities or update existing ones as needed.
          </p>
          <div className="amenities-container">
            <div className="amenity-select-field">
              <p>Select Amenities</p>
              <Select
                showSearch
                placeholder="Society Amenities"
                optionFilterProp="label"
                value={lastSelected || "Society Amenities"}
                onChange={handelSelectChange}
                options={[
                  ...(amenitiesList
                    ? amenitiesList.map((amenity) => ({
                        value: amenity.name,
                        label: formatAmenityName(amenity.name),
                      }))
                    : []),
                  { value: "custom", label: "Custom" },
                ]}
              />
            </div>
            {showCustomInput && (
              <div className="custom-amenity-input">
                <p>Custom Amenities</p>
                <div className="custom-field">
                  <Input
                    placeholder="Enter custom amenity"
                    value={customAmenity}
                    onChange={(e) => setCustomAmenity(e.target.value)}
                    onPressEnter={handleCustomAmenitySubmit}
                  />
                  <button onClick={handleCustomAmenitySubmit}>Add</button>
                </div>
              </div>
            )}
          </div>
          <div className="child-container">
            {amenities.length > 0 && (
              <>
                <p className="access-title">Amenities</p>
                <div className="selected-amenities">
                  {amenities.map((item) => (
                    <div
                      className="selected-checkbox"
                      key={item.selectedAmenity}
                    >
                      <div className="amenities-top">
                        <h3>{formatAmenityName(item.selectedAmenity)}</h3>
                        <span
                          onClick={() =>
                            handleRemoveAmenity(item.selectedAmenity)
                          }
                        >
                          <img src={trash_icn} alt="trash" />
                        </span>
                      </div>
                      <Checkbox
                        onChange={(e) =>
                          handelSelectedAmenities(
                            item.selectedAmenity,
                            e.target.checked
                          )
                        }
                        className="checkbox-container"
                        checked={item.isChecked}
                      >
                        Assign {formatAmenityName(item.selectedAmenity)} access
                        to residents with just a few clicks.
                      </Checkbox>
                    </div>
                  ))}
                </div>
              </>
            )}
            <div className="submit-container">
              <button onClick={handleAminitesSubmit}>
                {addAmenitiesData.isLoading ? (
                  <Loading type="spinner" color="#fff" />
                ) : (
                  "Save Permissions"
                )}
              </button>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: "Pre-Approved Visitor Access",
      children: (
        <div className="visitor-pin-main">
          <div className="visitor-pin-top">
            <p className="visitor-pin-text">
              Monitor and manage pre-approved visitor access for your society.
              You can easily add or remove access permissions as needed.
            </p>
          </div>
          <div className="visitor-pin-bottom">
            <h2>Pre-Approved Visitor Access</h2>
          </div>
          <div className="visitor-pin-main-container">
            <div className="visitor-pin-container">
              <h3>Allow Pre-Visitor Creation</h3>
              <Checkbox
                onChange={handleCheckboxChange}
                className="checkbox-container"
                checked={visitorPinCheck}
              >
                Enable this option to allow residents to create visitor entries
                in advance. Disable to restrict access to this feature.
              </Checkbox>
            </div>
            <div className="visitor-pin-container">
              <h3>Require Resident Approval for Visitor Entry</h3>
              <Checkbox
                onChange={handleDirectVisitorAccessChange}
                className="checkbox-container"
                checked={directVisitorAccessCheck}
              >
                When enabled, all visitors must be approved by a resident before
                entry. Disabling this allows visitors to enter without resident
                approval.
              </Checkbox>
            </div>
          </div>
          <div className="submit-container">
            <button
              onClick={handleVisitorPinSubmit}
              disabled={updateVisitorPinData.isLoading}
            >
              {updateVisitorPinData.isLoading ? (
                <Loading type="spinner" color="#fff" />
              ) : (
                "Set Pre-Approved Visitor Access"
              )}
            </button>
          </div>
        </div>
      ),
    },
  ];

  const onChange = (key) => {};

  const loading =
    amenityListData.isLoading ||
    addAmenitiesData.isLoading ||
    societyAmenitiesData.isLoading;

  return (
    <React.Fragment>
      {loading && <PageLoader />}
      <PermissionsPageComponent
        items={items}
        alignValue={alignValue}
        onChange={onChange}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    amenityListData: state.amenityListData,
    addAmenitiesData: state.addAmenitiesData,
    societyAmenitiesData: state.societyAmenitiesData,
    visitorPinSliceData: state.visitorPinSliceData,
    updateVisitorPinData: state.updateVisitorPinData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    callamenityListData: () => dispatch(amenityList()),
    callsocietyAmenitiesData: (id) => dispatch(societyAmenities(id)),
    callvisitorPinData: (id) => dispatch(visitorPinSlice(id)),
    calladdAmenitiesData: (data) => dispatch(addAmenities(data)),
    callupdateVisitorPinData: (data) => dispatch(updateVisitorPin(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Permissions);
